import { createReducer } from 'redux-starter-kit';
import { TOGGLE_MENU } from './actions';

interface BaseState {
  menuOpen: boolean;
}

const INITIAL_STATE: BaseState = {
  menuOpen: false
};

export default createReducer(INITIAL_STATE, {
  [TOGGLE_MENU]: state => {
    state.menuOpen = !state.menuOpen;
  }
});
